module.exports = __webpack_public_path__ + "img/gtl_white.b3e0dc82.png";